module.exports = __webpack_public_path__ + "media/store/images/x-7a7699a8b0ac566e03f564b71b64c1ae.svg";